import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Image from '../../../assets';

// Create styles using Material-UI's makeStyles
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: '3.5rem',
    paddingLeft: '2.7rem',
    paddingRight: '2.7rem',
    [theme.breakpoints.down('sm')]: {
      // For screens smaller than 'sm' (600px by default),
      // reduce padding to fit mobile.
      paddingTop: '2rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
  },
  header: {
    color: '#000000',
    fontSize: '20px',
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      // Slightly smaller text on mobile
      fontSize: '18px',
    },
  },
  subHeader: {
    color: '#707070',
    fontSize: '16px',
    fontWeight: 400,
    marginTop: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      // a bit smaller on mobile
      fontSize: '14px',
    },
  },
  imageWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      // On mobile, stack them vertically
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  clickableImage: {
    width: 156,
    height: 161,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      // Possibly shrink images on mobile
      width: 120,
      height: 125,
      marginBottom: '1rem',
    },
  },
}));

const LandingPage = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        Welcome to TiqConnect
      </div>
      <div className={classes.subHeader}>
        Our customer portal that allows you to manage your policies digitally.
      </div>

      <div className={classes.imageWrapper}>
        <img
          src={Image.onboardingNewUser}
          alt="New User"
          className={classes.clickableImage}
          onClick={() =>
            history.push('/Registration')
          }
        />
        <img
          src={Image.onboardingExisting}
          alt="Existing User"
          className={classes.clickableImage}
          onClick={() => history.push('/Login')}
        />
      </div>
    </div>
  );
};

export default LandingPage;
